<template>
  <div class="userList">
    <div class="userOne">
      <div class="row name">
        <div class="col-4 name-title">{{$t('name')}}</div>
        <div class="col-8 text-name"><input type="text" v-model="primaryVisitor.username" name="" :placeholder= "$t('typeTheName')"></div>
      </div>
      <div class="phone">
        <div class="row"  ref="phone">
          <div class="col-4 name-title add-phone">
            <span @click="toggleInput"> {{ primaryVisitor.pickedContact }}<i class="iconfont icon-down"></i></span>
            <div class="control-label" v-show="this.showOption">
              <div class="form-group">
                <input type="radio" id="tel" :value="$t('mobile')" v-model="primaryVisitor.pickedContact">
                <label for="tel" @click="hideContactSelect">{{$t('mobile')}}</label>
              </div>
              <div class="form-group">
                <input type="radio" id="mail" :value="$t('email')" v-model="primaryVisitor.pickedContact">
                <label for="mail" @click="hideContactSelect">{{$t('email')}}</label>
              </div>
            </div>
          </div>
          <div class="col-8 text-name">
            <input type="text" name="contact"
                  :placeholder=" this.$t('type') + this.primaryVisitor.pickedContact"
                  @blur="checkContact"
                  v-model="this.primaryVisitor.contact">
          </div>
        </div>
      </div>
      <label class="error-msg" v-if="primaryVisitor.pickedContact == this.$t('mobile')" v-show="!validContact">
        {{$t('rightMobile')}}
      </label>
      <label class="error-msg" v-else v-show="!validContact">{{$t('rightEmail')}}</label>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { regExp } from '@/utils/utils';
  export default{
    name: 'addUser',
    props: {
      userList: Array,
    },
    data() {
      return {
        showOption: false,
        primaryVisitor: {
           id: 0,
           username: '',
           pickedContact: this.$t('mobile'),
           contact: '',
        },
        validContact: true,
      }
    },
    methods: {
      toggleInput() {
        this.showOption = true;
      },
      checkContact() {
        if (this.primaryVisitor.pickedContact === this.$t('mobile')) {
          this.validContact = regExp.phone.test(this.primaryVisitor.contact);
        } else {
          this.validContact = regExp.email.test(this.primaryVisitor.contact);
        }
      },
      hideContactSelect() {
        // console.log(this.primaryVisitor.pickedContact);
        this.showOption = false;
        this.primaryVisitor.contact = '';
        this.validContact = true;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>